var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFriendsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8932 22.0776C18.6956 22.0579 18.4584 22.0579 18.2411 22.0776C13.5377 21.9195 9.80273 18.066 9.80273 13.3231C9.80273 8.48145 13.7156 4.54883 18.577 4.54883C23.4187 4.54883 27.3513 8.48145 27.3513 13.3231C27.3315 18.066 23.5965 21.9195 18.8932 22.0776Z",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2205 8.50195C37.0543 8.50195 40.1372 11.6046 40.1372 15.4186C40.1372 19.1536 37.1729 22.197 33.4774 22.3353C33.3193 22.3155 33.1415 22.3155 32.9636 22.3353",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01208 29.3705C4.2297 32.572 4.2297 37.7891 9.01208 40.9708C14.4466 44.607 23.3592 44.607 28.7937 40.9708C33.5761 37.7693 33.5761 32.5522 28.7937 29.3705C23.379 25.7541 14.4664 25.7541 9.01208 29.3705Z",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0344 40.1203C38.4573 39.8239 39.8011 39.2508 40.9078 38.401C43.9906 36.0889 43.9906 32.2748 40.9078 29.9627C39.8209 29.1327 38.4968 28.5794 37.0937 28.2632",
    stroke: "#292D32",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFriendsIcon);
export default __webpack_public_path__ + "static/media/friends-icon.995a221b8c27bb8a8dda51f3cf4338eb.svg";
export { ForwardRef as ReactComponent };